import docCookies from 'doc-cookies';
import { load } from 'recaptcha-v3';
import { RECAPTCHA_SITE_KEY } from '../misc/consts';
import { getXsfrToken } from '../alpine-functions';

export default () => ({
  form: null,
  sent: false,
  failed: false,
  sending: false,

  init() {
    this.form = this.$el;
  },

  get action() {
    return this.form.action;
  },

  resetForm() {
    this.form.reset();
    this.$nextTick(() => {
      this.$dispatch('select:reset');
    });
  },

  isValid() {
    const isValid = this.checkFormValidity();
    return isValid;
  },

  checkFormValidity() {
    const form = this.form;
    let isValid = true;

    // Loop through all form elements
    for (let i = 0; i < form.elements.length; i++) {
      const element = form.elements[i];

      // Check if the element is an input and is not valid
      if (!element.checkValidity()) {
        // Set the element's border color to indicate it's invalid (for visual feedback)

        // Set the overall form validity to false
        isValid = false;
        this.form.reportValidity();
        this.submissionFailed('Neplatná hodnota pole: ' + element.name);
        break;
      }
    }

    return isValid;
  },

  async getRecaptchaToken(action) {
    const recaptcha = await load(RECAPTCHA_SITE_KEY);
    return await recaptcha.execute(action);
  },

  async send() {
    if (!this.isValid()) {
      return false;
    }
    this.sending = true;
    await getXsfrToken();

    const data = new URLSearchParams(new FormData(this.form));

    const recaptchaAction = this.action.replace(/[^A-Za-z]/g, '');
    const token = await this.getRecaptchaToken(recaptchaAction);

    data.append('recaptcha_token', token);
    data.append('recaptcha_action', recaptchaAction);
    data.delete('_token');

    fetch(this.action, {
      body: data,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
      },
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          this.resetForm();
          this.sent = true;
          this.sending = false;
          return response.json();
        }
        throw new Error('Something went wrong.');
      })
      .then((data) => {
        console.log('Success:', data);
        if (data.submission.transaction_id) {
          this.pushPurchaseToDataLayer(data.submission);
        } else {
          this.contactFormToDataLayer(data.submission);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        this.sent = true;
        this.failed = true;
        this.submissionFailed('Chyba ve zpracování formuláře systémem');
      });
  },

  contactFormToDataLayer(data) {
    console.log('pushToDataLayer', data);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'formular_odeslany',
    });
  },

  pushPurchaseToDataLayer(data) {
    console.log('pushToDataLayer', data);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'purchase', // The name of the event to trigger in GTM
      ecommerce: {
        transaction_id: data.transaction_id,
        value: data.transaction_value ?? 0,
        tax: 0,
        shipping: 0,
        currency: 'CZK',
        items: [
          {
            item_id: this.createSlug(data.internet_option),
            item_name: data.internet_option,
            price: data.transaction_value,
            item_category: this.getServiceName(data), // 'Internet + TV' : 'Internet'
            item_category2: data.address, // Adresa připojení (municipalita nebo konkrétní adresa)
            item_category3: data.own_ip ? true : false, // Vlastní IP adresa (Ano/Ne)
            item_category4: data.bigger_upload ? true : false, // Větší upload (Ano/Ne)
            item_category5: data.express ? true : false, // Express instalace (Ano/Ne)
            item_variant: data.payment, // Doba fixace
          },
        ],
      },
    });
  },

  submissionFailed(label) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'formular_fail',
      label: label, // zobrazená chybová hláška
    });
  },

  getServiceName(data) {
    return data.digital_tv === 'Ano' ? 'Internet + TV' : 'Internet';
  },

  createSlug(str) {
    // Convert to lowercase
    str = str.toLowerCase();

    // Replace spaces with hyphens
    str = str.replace(/\s+/g, '-');

    // Remove special characters and diacritics using a regular expression
    str = str.replace(/[^\w-]+/g, '');

    return str;
  },
});
